import { Group, Stack, Text } from "@mantine/core";
import { useId } from "react";

import { palette } from "../palette";

/** The StockVol mark: a lidar sweep arc over two stockpiles, on a brand tile. */
export function LogoMark({ size = 28 }: { size?: number }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`sv-tile-${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={palette.brand[4]} />
          <stop offset="1" stopColor={palette.brand[8]} />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#sv-tile-${id})`} />
      <path d="M8 9.5 A11 11 0 0 1 24 9.5" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
      <path
        d="M11.5 11.8 A6.5 6.5 0 0 1 20.5 11.8"
        fill="none"
        stroke="#fff"
        strokeOpacity="0.55"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="16" cy="6.05" r="1.5" fill="#fff" />
      <path d="M4.5 25.5 L12.5 15 L15.5 18.2 L19.5 13.5 L27.5 25.5 Z" fill="#fff" />
    </svg>
  );
}

/** The mark with the wordmark (and an optional tagline under it). */
export function Logo({
  size = 30,
  tone = "onDark",
  tagline,
}: {
  size?: number;
  tone?: "onDark" | "onLight";
  tagline?: string;
}) {
  const ink = tone === "onDark" ? "#FFFFFF" : palette.text;
  const sub = tone === "onDark" ? palette.side.muted : palette.muted;
  return (
    <Group gap={10} wrap="nowrap">
      <LogoMark size={size} />
      <Stack gap={0}>
        <Text fw={700} fz={17} lh={1.1} c={ink} style={{ letterSpacing: "-0.01em" }}>
          StockVol
        </Text>
        {tagline && (
          <Text fz={11} lh={1.3} c={sub}>
            {tagline}
          </Text>
        )}
      </Stack>
    </Group>
  );
}
